import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import ScheduleState, {HodidayList, ISchedule, ITimeline, ScheduleList, ScheduleUserList} from './states'
import _ from 'lodash'
import { IPatient } from '../patient/states'
import { IJob } from '../job/states'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<ScheduleState> = {
  [mutationType.GET_LISTS](
    state: ScheduleState,
    data: ScheduleList,
  ): void {
    state.list = data
  },
  [mutationType.GET_BY_ID](
    state: ScheduleState,
    data: ISchedule,
  ): void {
    state.byId = data
  },
  [mutationType.UPDATE](
    state: ScheduleState,
    data: object,
  ): void {
    state.update = data
  },
  [mutationType.GET_LIST_USERS](
    state: ScheduleState,
    data: ScheduleUserList,
  ): void {
    state.listUser = data
  },
  [mutationType.GET_LIST_BY_USER](
    state: ScheduleState,
    data: ScheduleUserList[],
  ): void {
    state.listByUser = data
  },
  [mutationType.GET_LIST_BY_JOB](
    state: ScheduleState,
    data: ScheduleUserList,
  ): void {
    state.listByJob = data
  },
  [mutationType.GET_HOLIDAY_LISTS](
    state: ScheduleState,
    data: HodidayList,
  ): void {
    state.listHoliday = data
  },
  [mutationType.STOP_JOB](
    state: ScheduleState,
    data: object,
  ): void {
    state.stopJob = data
  },
  [mutationType.GET_SCHEDULE_JOB_LOG](
    state: ScheduleState,
    data: ITimeline & IJob,
  ): void {
    state.logJobList = data
  },
  [mutationType.GET_SCHEDULE_PATIENT_LOG](
    state: ScheduleState,
    data: ITimeline & IPatient,
  ): void {
    state.logPatientList = data
  },
}

export default mutations
